module.exports = __webpack_public_path__ + "img/场馆预约.dca4b3f2.png";